 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";
import FilterMapModal from "../../commonComponents/gridView/filter/FilterMapModal";

const MapModalContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" gridSize={3} modalType="map-modal" carShow={9} />
      <FilterMapModal type="property" />
    </>
  );
};

export default MapModalContainer;
